import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
const defaultOptions = {};
var AnalyticsAdRatingScore = /* @__PURE__ */ ((AnalyticsAdRatingScore2) => {
  AnalyticsAdRatingScore2["LOW"] = "LOW";
  AnalyticsAdRatingScore2["NORMAL"] = "NORMAL";
  AnalyticsAdRatingScore2["HIGH"] = "HIGH";
  return AnalyticsAdRatingScore2;
})(AnalyticsAdRatingScore || {});
var AnalyticsAdRatingConfidence = /* @__PURE__ */ ((AnalyticsAdRatingConfidence2) => {
  AnalyticsAdRatingConfidence2["LOW"] = "LOW";
  AnalyticsAdRatingConfidence2["HIGH"] = "HIGH";
  return AnalyticsAdRatingConfidence2;
})(AnalyticsAdRatingConfidence || {});
var AnalyticsBenchmarkScenario = /* @__PURE__ */ ((AnalyticsBenchmarkScenario2) => {
  AnalyticsBenchmarkScenario2["EXACT"] = "EXACT";
  AnalyticsBenchmarkScenario2["IDEAL"] = "IDEAL";
  AnalyticsBenchmarkScenario2["EXACT_REGIONAL"] = "EXACT_REGIONAL";
  AnalyticsBenchmarkScenario2["IDEAL_REGIONAL"] = "IDEAL_REGIONAL";
  AnalyticsBenchmarkScenario2["EXACT_COUNTRY"] = "EXACT_COUNTRY";
  AnalyticsBenchmarkScenario2["IDEAL_COUNTRY"] = "IDEAL_COUNTRY";
  AnalyticsBenchmarkScenario2["SUBCLASS_LOCATION"] = "SUBCLASS_LOCATION";
  AnalyticsBenchmarkScenario2["SUBCLASS_REGIONAL"] = "SUBCLASS_REGIONAL";
  AnalyticsBenchmarkScenario2["SUBCLASS_COUNTRY"] = "SUBCLASS_COUNTRY";
  AnalyticsBenchmarkScenario2["COUNTRY"] = "COUNTRY";
  return AnalyticsBenchmarkScenario2;
})(AnalyticsBenchmarkScenario || {});
var AnalyticsPostTypeCategory = /* @__PURE__ */ ((AnalyticsPostTypeCategory2) => {
  AnalyticsPostTypeCategory2["DIRECT"] = "DIRECT";
  AnalyticsPostTypeCategory2["INDIRECT"] = "INDIRECT";
  return AnalyticsPostTypeCategory2;
})(AnalyticsPostTypeCategory || {});
var AnalyticsSalaryType = /* @__PURE__ */ ((AnalyticsSalaryType2) => {
  AnalyticsSalaryType2["ANNUAL_COMMISSION"] = "ANNUAL_COMMISSION";
  AnalyticsSalaryType2["ANNUAL_PACKAGE"] = "ANNUAL_PACKAGE";
  AnalyticsSalaryType2["COMMISSION_ONLY"] = "COMMISSION_ONLY";
  AnalyticsSalaryType2["MONTHLY"] = "MONTHLY";
  AnalyticsSalaryType2["HOURLY"] = "HOURLY";
  return AnalyticsSalaryType2;
})(AnalyticsSalaryType || {});
var AnalyticsWorkType = /* @__PURE__ */ ((AnalyticsWorkType2) => {
  AnalyticsWorkType2["CASUAL"] = "CASUAL";
  AnalyticsWorkType2["CONTRACT"] = "CONTRACT";
  AnalyticsWorkType2["FULL_TIME"] = "FULL_TIME";
  AnalyticsWorkType2["PART_TIME"] = "PART_TIME";
  return AnalyticsWorkType2;
})(AnalyticsWorkType || {});
var AnalyticsAdType = /* @__PURE__ */ ((AnalyticsAdType2) => {
  AnalyticsAdType2["BRANDED"] = "BRANDED";
  AnalyticsAdType2["CLASSIC"] = "CLASSIC";
  AnalyticsAdType2["PREMIUM"] = "PREMIUM";
  AnalyticsAdType2["STANDOUT"] = "STANDOUT";
  AnalyticsAdType2["AUTO_INCLUDE"] = "AUTO_INCLUDE";
  AnalyticsAdType2["BASIC"] = "BASIC";
  return AnalyticsAdType2;
})(AnalyticsAdType || {});
var CandidateLabel = /* @__PURE__ */ ((CandidateLabel2) => {
  CandidateLabel2["CANDIDATES"] = "CANDIDATES";
  CandidateLabel2["APPLICATION_STARTS"] = "APPLICATION_STARTS";
  return CandidateLabel2;
})(CandidateLabel || {});
var RecommendationType = /* @__PURE__ */ ((RecommendationType2) => {
  RecommendationType2["LOW_CLICK"] = "LOW_CLICK";
  RecommendationType2["LOW_APPLY"] = "LOW_APPLY";
  RecommendationType2["REVEAL_SALARY"] = "REVEAL_SALARY";
  RecommendationType2["LOW_SALARY"] = "LOW_SALARY";
  RecommendationType2["GRANULAR_LOCATION"] = "GRANULAR_LOCATION";
  RecommendationType2["BRANDED_AD"] = "BRANDED_AD";
  RecommendationType2["ROLE_REQUIREMENTS"] = "ROLE_REQUIREMENTS";
  RecommendationType2["TALENT_SEARCH"] = "TALENT_SEARCH";
  return RecommendationType2;
})(RecommendationType || {});
var AdUsageAdStatus = /* @__PURE__ */ ((AdUsageAdStatus2) => {
  AdUsageAdStatus2["ACTIVE"] = "ACTIVE";
  AdUsageAdStatus2["EXPIRED"] = "EXPIRED";
  return AdUsageAdStatus2;
})(AdUsageAdStatus || {});
var AdTipsType = /* @__PURE__ */ ((AdTipsType2) => {
  AdTipsType2["REVIEW_AD_SUMMARY"] = "REVIEW_AD_SUMMARY";
  AdTipsType2["REVIEW_AD_DETAILS"] = "REVIEW_AD_DETAILS";
  AdTipsType2["REVEAL_SALARY"] = "REVEAL_SALARY";
  AdTipsType2["INCREASE_SALARY"] = "INCREASE_SALARY";
  AdTipsType2["ADD_SPECIFIC_LOCATION"] = "ADD_SPECIFIC_LOCATION";
  AdTipsType2["MAXIMISE_BRANDING"] = "MAXIMISE_BRANDING";
  AdTipsType2["ADD_QUESTIONS"] = "ADD_QUESTIONS";
  AdTipsType2["NO_TIPS"] = "NO_TIPS";
  return AdTipsType2;
})(AdTipsType || {});
var AdUsageAdType = /* @__PURE__ */ ((AdUsageAdType2) => {
  AdUsageAdType2["BASIC"] = "BASIC";
  AdUsageAdType2["CLASSIC"] = "CLASSIC";
  AdUsageAdType2["PREMIUM"] = "PREMIUM";
  AdUsageAdType2["BRANDED"] = "BRANDED";
  AdUsageAdType2["STANDOUT"] = "STANDOUT";
  return AdUsageAdType2;
})(AdUsageAdType || {});
var AdRepost = /* @__PURE__ */ ((AdRepost2) => {
  AdRepost2["NOT_REPOST"] = "NOT_REPOST";
  AdRepost2["REPOST"] = "REPOST";
  return AdRepost2;
})(AdRepost || {});
var AdRatingType = /* @__PURE__ */ ((AdRatingType2) => {
  AdRatingType2["HIGH"] = "HIGH";
  AdRatingType2["NORMAL"] = "NORMAL";
  AdRatingType2["LOW"] = "LOW";
  AdRatingType2["TOO_SOON_TO_RATE"] = "TOO_SOON_TO_RATE";
  AdRatingType2["UNABLE_TO_RATE"] = "UNABLE_TO_RATE";
  return AdRatingType2;
})(AdRatingType || {});
var FiltersAdRatingType = /* @__PURE__ */ ((FiltersAdRatingType2) => {
  FiltersAdRatingType2["HIGH"] = "HIGH";
  FiltersAdRatingType2["NORMAL"] = "NORMAL";
  FiltersAdRatingType2["LOW"] = "LOW";
  FiltersAdRatingType2["NO_RATING"] = "NO_RATING";
  return FiltersAdRatingType2;
})(FiltersAdRatingType || {});
var JobAdRating = /* @__PURE__ */ ((JobAdRating2) => {
  JobAdRating2["HIGH"] = "HIGH";
  JobAdRating2["LOW"] = "LOW";
  JobAdRating2["NORMAL"] = "NORMAL";
  return JobAdRating2;
})(JobAdRating || {});
var CacheControlScope = /* @__PURE__ */ ((CacheControlScope2) => {
  CacheControlScope2["PUBLIC"] = "PUBLIC";
  CacheControlScope2["PRIVATE"] = "PRIVATE";
  return CacheControlScope2;
})(CacheControlScope || {});
var BrandState = /* @__PURE__ */ ((BrandState2) => {
  BrandState2["ACTIVE"] = "ACTIVE";
  BrandState2["INACTIVE"] = "INACTIVE";
  BrandState2["DELETED"] = "DELETED";
  return BrandState2;
})(BrandState || {});
var BrandOwnerType = /* @__PURE__ */ ((BrandOwnerType2) => {
  BrandOwnerType2["seekId"] = "seekId";
  BrandOwnerType2["advertiserId"] = "advertiserId";
  return BrandOwnerType2;
})(BrandOwnerType || {});
var BrandAssetTypeEnum = /* @__PURE__ */ ((BrandAssetTypeEnum2) => {
  BrandAssetTypeEnum2["logo"] = "logo";
  BrandAssetTypeEnum2["cover"] = "cover";
  return BrandAssetTypeEnum2;
})(BrandAssetTypeEnum || {});
var ContractType = /* @__PURE__ */ ((ContractType2) => {
  ContractType2["SUBSCRIPTION"] = "SUBSCRIPTION";
  ContractType2["AD_PACK"] = "AD_PACK";
  ContractType2["SEEK_CONTRACT"] = "SEEK_CONTRACT";
  ContractType2["MASTER_AGREEMENT"] = "MASTER_AGREEMENT";
  ContractType2["TALENT_SEARCH_CONTRACT"] = "TALENT_SEARCH_CONTRACT";
  ContractType2["PRICING_GROUP"] = "PRICING_GROUP";
  return ContractType2;
})(ContractType || {});
var CreditCardBrandInput = /* @__PURE__ */ ((CreditCardBrandInput2) => {
  CreditCardBrandInput2["AMEX"] = "AMEX";
  CreditCardBrandInput2["VISA"] = "VISA";
  CreditCardBrandInput2["MASTER_CARD"] = "MASTER_CARD";
  return CreditCardBrandInput2;
})(CreditCardBrandInput || {});
var GuidedDetailsType = /* @__PURE__ */ ((GuidedDetailsType2) => {
  GuidedDetailsType2["ABOUT_BUSINESS"] = "ABOUT_BUSINESS";
  GuidedDetailsType2["BENEFITS"] = "BENEFITS";
  GuidedDetailsType2["QUALIFICATIONS"] = "QUALIFICATIONS";
  GuidedDetailsType2["RESPONSIBILITIES"] = "RESPONSIBILITIES";
  return GuidedDetailsType2;
})(GuidedDetailsType || {});
var DraftJobWritingMode = /* @__PURE__ */ ((DraftJobWritingMode2) => {
  DraftJobWritingMode2["STANDARD"] = "STANDARD";
  DraftJobWritingMode2["GUIDED"] = "GUIDED";
  return DraftJobWritingMode2;
})(DraftJobWritingMode || {});
var DraftJobSalaryCurrency = /* @__PURE__ */ ((DraftJobSalaryCurrency2) => {
  DraftJobSalaryCurrency2["AUD"] = "AUD";
  DraftJobSalaryCurrency2["BDT"] = "BDT";
  DraftJobSalaryCurrency2["CNY"] = "CNY";
  DraftJobSalaryCurrency2["EUR"] = "EUR";
  DraftJobSalaryCurrency2["GBP"] = "GBP";
  DraftJobSalaryCurrency2["HKD"] = "HKD";
  DraftJobSalaryCurrency2["IDR"] = "IDR";
  DraftJobSalaryCurrency2["INR"] = "INR";
  DraftJobSalaryCurrency2["JPY"] = "JPY";
  DraftJobSalaryCurrency2["MYR"] = "MYR";
  DraftJobSalaryCurrency2["NZD"] = "NZD";
  DraftJobSalaryCurrency2["PHP"] = "PHP";
  DraftJobSalaryCurrency2["SGD"] = "SGD";
  DraftJobSalaryCurrency2["THB"] = "THB";
  DraftJobSalaryCurrency2["USD"] = "USD";
  DraftJobSalaryCurrency2["VND"] = "VND";
  return DraftJobSalaryCurrency2;
})(DraftJobSalaryCurrency || {});
var DraftJobFlowType = /* @__PURE__ */ ((DraftJobFlowType2) => {
  DraftJobFlowType2["CREATE"] = "CREATE";
  DraftJobFlowType2["EDIT"] = "EDIT";
  return DraftJobFlowType2;
})(DraftJobFlowType || {});
var DraftJobProgress = /* @__PURE__ */ ((DraftJobProgress2) => {
  DraftJobProgress2["CLASSIFY"] = "CLASSIFY";
  DraftJobProgress2["SELECT_AD_TYPE"] = "SELECT_AD_TYPE";
  DraftJobProgress2["WRITE"] = "WRITE";
  DraftJobProgress2["MANAGE"] = "MANAGE";
  DraftJobProgress2["PAY_AND_POST"] = "PAY_AND_POST";
  return DraftJobProgress2;
})(DraftJobProgress || {});
var DraftJobPaymentOption = /* @__PURE__ */ ((DraftJobPaymentOption2) => {
  DraftJobPaymentOption2["CONTRACT"] = "CONTRACT";
  DraftJobPaymentOption2["CREDIT_CARD"] = "CREDIT_CARD";
  DraftJobPaymentOption2["INVOICE"] = "INVOICE";
  DraftJobPaymentOption2["SAVED_CREDIT_CARD"] = "SAVED_CREDIT_CARD";
  return DraftJobPaymentOption2;
})(DraftJobPaymentOption || {});
var DraftStatus = /* @__PURE__ */ ((DraftStatus2) => {
  DraftStatus2["OPEN"] = "OPEN";
  DraftStatus2["CLOSED"] = "CLOSED";
  DraftStatus2["DELETED"] = "DELETED";
  return DraftStatus2;
})(DraftStatus || {});
var GuaranteedHireProductCode = /* @__PURE__ */ ((GuaranteedHireProductCode2) => {
  GuaranteedHireProductCode2["AUSKGHRB"] = "AUSKGHRB";
  GuaranteedHireProductCode2["NZSKCONB"] = "NZSKCONB";
  return GuaranteedHireProductCode2;
})(GuaranteedHireProductCode || {});
var BillingStatus = /* @__PURE__ */ ((BillingStatus2) => {
  BillingStatus2["OK"] = "OK";
  BillingStatus2["ON_CREDIT_HOLD"] = "ON_CREDIT_HOLD";
  return BillingStatus2;
})(BillingStatus || {});
var HirerGroup = /* @__PURE__ */ ((HirerGroup2) => {
  HirerGroup2["ADVERTISER"] = "ADVERTISER";
  HirerGroup2["AGENT"] = "AGENT";
  HirerGroup2["RECRUITMENT_SOFTWARE_PROVIDER"] = "RECRUITMENT_SOFTWARE_PROVIDER";
  return HirerGroup2;
})(HirerGroup || {});
var HirerType = /* @__PURE__ */ ((HirerType2) => {
  HirerType2["CORPORATE"] = "CORPORATE";
  HirerType2["JORA_LOCAL"] = "JORA_LOCAL";
  HirerType2["GOVERNMENT"] = "GOVERNMENT";
  HirerType2["RECRUITER"] = "RECRUITER";
  HirerType2["SME"] = "SME";
  HirerType2["SUBSCRIPTION_PARTNER"] = "SUBSCRIPTION_PARTNER";
  return HirerType2;
})(HirerType || {});
var PricingModel = /* @__PURE__ */ ((PricingModel2) => {
  PricingModel2["FIXED"] = "FIXED";
  PricingModel2["HORIZON"] = "HORIZON";
  return PricingModel2;
})(PricingModel || {});
var PriceVisibility = /* @__PURE__ */ ((PriceVisibility2) => {
  PriceVisibility2["SHOW_RETAIL_PRICE"] = "SHOW_RETAIL_PRICE";
  PriceVisibility2["SHOW_DISCOUNTED_PRICE"] = "SHOW_DISCOUNTED_PRICE";
  PriceVisibility2["HIDE_PRICE"] = "HIDE_PRICE";
  return PriceVisibility2;
})(PriceVisibility || {});
var HirerAccountStatus = /* @__PURE__ */ ((HirerAccountStatus2) => {
  HirerAccountStatus2["ACTIVE"] = "ACTIVE";
  HirerAccountStatus2["DEACTIVATED"] = "DEACTIVATED";
  HirerAccountStatus2["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
  return HirerAccountStatus2;
})(HirerAccountStatus || {});
var AccountActivationStatus = /* @__PURE__ */ ((AccountActivationStatus2) => {
  AccountActivationStatus2["ACTIVE"] = "ACTIVE";
  AccountActivationStatus2["PENDING"] = "PENDING";
  return AccountActivationStatus2;
})(AccountActivationStatus || {});
var HirerActivityType = /* @__PURE__ */ ((HirerActivityType2) => {
  HirerActivityType2["NOTE_ADDED"] = "NOTE_ADDED";
  HirerActivityType2["NOTE_DELETED"] = "NOTE_DELETED";
  return HirerActivityType2;
})(HirerActivityType || {});
var TalentSearchAccess = /* @__PURE__ */ ((TalentSearchAccess2) => {
  TalentSearchAccess2["STANDARD"] = "STANDARD";
  TalentSearchAccess2["PREMIUM"] = "PREMIUM";
  TalentSearchAccess2["DISABLED"] = "DISABLED";
  TalentSearchAccess2["SYSTEM_DOWN"] = "SYSTEM_DOWN";
  return TalentSearchAccess2;
})(TalentSearchAccess || {});
var HirerJobStatusFilter = /* @__PURE__ */ ((HirerJobStatusFilter2) => {
  HirerJobStatusFilter2["OPEN"] = "OPEN";
  HirerJobStatusFilter2["CLOSED"] = "CLOSED";
  return HirerJobStatusFilter2;
})(HirerJobStatusFilter || {});
var HirerJobStatus = /* @__PURE__ */ ((HirerJobStatus2) => {
  HirerJobStatus2["PENDING"] = "PENDING";
  HirerJobStatus2["OPEN"] = "OPEN";
  HirerJobStatus2["CLOSED"] = "CLOSED";
  return HirerJobStatus2;
})(HirerJobStatus || {});
var HirerJobPostChannel = /* @__PURE__ */ ((HirerJobPostChannel2) => {
  HirerJobPostChannel2["DIRECT"] = "DIRECT";
  HirerJobPostChannel2["INDIRECT"] = "INDIRECT";
  return HirerJobPostChannel2;
})(HirerJobPostChannel || {});
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["pending"] = "pending";
  return InvoiceStatus2;
})(InvoiceStatus || {});
var ExpireReason = /* @__PURE__ */ ((ExpireReason2) => {
  ExpireReason2["NATURAL"] = "NATURAL";
  ExpireReason2["MANUAL"] = "MANUAL";
  ExpireReason2["FRAUDULENT"] = "FRAUDULENT";
  ExpireReason2["NONCOMPLIANT"] = "NONCOMPLIANT";
  return ExpireReason2;
})(ExpireReason || {});
var JobSalaryCurrency = /* @__PURE__ */ ((JobSalaryCurrency2) => {
  JobSalaryCurrency2["AUD"] = "AUD";
  JobSalaryCurrency2["BDT"] = "BDT";
  JobSalaryCurrency2["CNY"] = "CNY";
  JobSalaryCurrency2["EUR"] = "EUR";
  JobSalaryCurrency2["GBP"] = "GBP";
  JobSalaryCurrency2["HKD"] = "HKD";
  JobSalaryCurrency2["JPY"] = "JPY";
  JobSalaryCurrency2["IDR"] = "IDR";
  JobSalaryCurrency2["INR"] = "INR";
  JobSalaryCurrency2["MYR"] = "MYR";
  JobSalaryCurrency2["NZD"] = "NZD";
  JobSalaryCurrency2["PHP"] = "PHP";
  JobSalaryCurrency2["SGD"] = "SGD";
  JobSalaryCurrency2["THB"] = "THB";
  JobSalaryCurrency2["USD"] = "USD";
  JobSalaryCurrency2["VND"] = "VND";
  return JobSalaryCurrency2;
})(JobSalaryCurrency || {});
var JobStatus = /* @__PURE__ */ ((JobStatus2) => {
  JobStatus2["ACTIVE"] = "ACTIVE";
  JobStatus2["EXPIRED"] = "EXPIRED";
  JobStatus2["PENDING"] = "PENDING";
  JobStatus2["SUSPENDED"] = "SUSPENDED";
  JobStatus2["PENDING_ACCOUNT_APPROVAL"] = "PENDING_ACCOUNT_APPROVAL";
  return JobStatus2;
})(JobStatus || {});
var JobAdType = /* @__PURE__ */ ((JobAdType2) => {
  JobAdType2["CLASSIC"] = "CLASSIC";
  JobAdType2["BRANDED"] = "BRANDED";
  JobAdType2["PREMIUM"] = "PREMIUM";
  JobAdType2["BRANDED_UPGRADE"] = "BRANDED_UPGRADE";
  JobAdType2["GUARANTEED"] = "GUARANTEED";
  JobAdType2["CONCIERGE"] = "CONCIERGE";
  return JobAdType2;
})(JobAdType || {});
var WorkType = /* @__PURE__ */ ((WorkType2) => {
  WorkType2["FULLTIME"] = "FULLTIME";
  WorkType2["PARTTIME"] = "PARTTIME";
  WorkType2["CASUAL"] = "CASUAL";
  WorkType2["CONTRACT_TEMP"] = "CONTRACT_TEMP";
  return WorkType2;
})(WorkType || {});
var SalaryType = /* @__PURE__ */ ((SalaryType2) => {
  SalaryType2["ANNUAL_PACKAGE"] = "ANNUAL_PACKAGE";
  SalaryType2["ANNUAL_COMMISSION"] = "ANNUAL_COMMISSION";
  SalaryType2["COMMISSION_ONLY"] = "COMMISSION_ONLY";
  SalaryType2["HOURLY_RATE"] = "HOURLY_RATE";
  SalaryType2["MONTHLY"] = "MONTHLY";
  return SalaryType2;
})(SalaryType || {});
var JobAdBookingCountryCode = /* @__PURE__ */ ((JobAdBookingCountryCode2) => {
  JobAdBookingCountryCode2["AU"] = "AU";
  JobAdBookingCountryCode2["NZ"] = "NZ";
  JobAdBookingCountryCode2["HK"] = "HK";
  JobAdBookingCountryCode2["TH"] = "TH";
  JobAdBookingCountryCode2["MY"] = "MY";
  JobAdBookingCountryCode2["SG"] = "SG";
  JobAdBookingCountryCode2["ID"] = "ID";
  JobAdBookingCountryCode2["PH"] = "PH";
  return JobAdBookingCountryCode2;
})(JobAdBookingCountryCode || {});
var PublishJobAdProductCode = /* @__PURE__ */ ((PublishJobAdProductCode2) => {
  PublishJobAdProductCode2["AUSKGHRB"] = "AUSKGHRB";
  PublishJobAdProductCode2["CONCIERGE"] = "CONCIERGE";
  return PublishJobAdProductCode2;
})(PublishJobAdProductCode || {});
var LocationContext = /* @__PURE__ */ ((LocationContext2) => {
  LocationContext2["JOB_POSTING"] = "JOB_POSTING";
  LocationContext2["TALENT_SEARCH"] = "TALENT_SEARCH";
  return LocationContext2;
})(LocationContext || {});
var Frequency = /* @__PURE__ */ ((Frequency2) => {
  Frequency2["DAILY"] = "DAILY";
  Frequency2["WEEKLY"] = "WEEKLY";
  Frequency2["EVERY_APPLICATION"] = "EVERY_APPLICATION";
  Frequency2["NEVER"] = "NEVER";
  return Frequency2;
})(Frequency || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["INVOICE"] = "INVOICE";
  PaymentMethod2["CREDIT_CARD"] = "CREDIT_CARD";
  PaymentMethod2["CONTRACT"] = "CONTRACT";
  return PaymentMethod2;
})(PaymentMethod || {});
var ProductTypeInput = /* @__PURE__ */ ((ProductTypeInput2) => {
  ProductTypeInput2["JOB_AD"] = "JOB_AD";
  ProductTypeInput2["JOB_AD_EDIT"] = "JOB_AD_EDIT";
  ProductTypeInput2["JOB_AD_EXTEND"] = "JOB_AD_EXTEND";
  ProductTypeInput2["AD_BUDGET"] = "AD_BUDGET";
  ProductTypeInput2["CATALOGUE_PRODUCT"] = "CATALOGUE_PRODUCT";
  return ProductTypeInput2;
})(ProductTypeInput || {});
var DrawdownType = /* @__PURE__ */ ((DrawdownType2) => {
  DrawdownType2["PACK"] = "PACK";
  DrawdownType2["BALANCE"] = "BALANCE";
  DrawdownType2["PAYABLE"] = "PAYABLE";
  return DrawdownType2;
})(DrawdownType || {});
var StripePaymentMethod = /* @__PURE__ */ ((StripePaymentMethod2) => {
  StripePaymentMethod2["card"] = "card";
  StripePaymentMethod2["fpx"] = "fpx";
  StripePaymentMethod2["id_bank_transfer"] = "id_bank_transfer";
  StripePaymentMethod2["paynow"] = "paynow";
  StripePaymentMethod2["promptpay"] = "promptpay";
  return StripePaymentMethod2;
})(StripePaymentMethod || {});
var PaymentMethodType2C2P = /* @__PURE__ */ ((PaymentMethodType2C2P2) => {
  PaymentMethodType2C2P2["WEBPAY"] = "WEBPAY";
  PaymentMethodType2C2P2["DPAY"] = "DPAY";
  PaymentMethodType2C2P2["QR"] = "QR";
  return PaymentMethodType2C2P2;
})(PaymentMethodType2C2P || {});
var Bank2C2P = /* @__PURE__ */ ((Bank2C2P2) => {
  Bank2C2P2["bca"] = "bca";
  Bank2C2P2["bni"] = "bni";
  Bank2C2P2["bri"] = "bri";
  Bank2C2P2["cimb"] = "cimb";
  Bank2C2P2["mandiri"] = "mandiri";
  Bank2C2P2["kbank"] = "kbank";
  Bank2C2P2["scb"] = "scb";
  Bank2C2P2["bbl"] = "bbl";
  Bank2C2P2["ktb"] = "ktb";
  Bank2C2P2["bay"] = "bay";
  Bank2C2P2["tmb"] = "tmb";
  Bank2C2P2["uob"] = "uob";
  Bank2C2P2["bpi"] = "bpi";
  Bank2C2P2["unionbank"] = "unionbank";
  return Bank2C2P2;
})(Bank2C2P || {});
var ChannelCode = /* @__PURE__ */ ((ChannelCode2) => {
  ChannelCode2["OVO"] = "OVO";
  ChannelCode2["DANA"] = "DANA";
  ChannelCode2["LINKAJA"] = "LINKAJA";
  ChannelCode2["SHPQR"] = "SHPQR";
  ChannelCode2["GCASH"] = "GCASH";
  ChannelCode2["PAYMAYA"] = "PAYMAYA";
  ChannelCode2["GRAB"] = "GRAB";
  ChannelCode2["PAYPAL"] = "PAYPAL";
  ChannelCode2["ALIPAYHK"] = "ALIPAYHK";
  return ChannelCode2;
})(ChannelCode || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["AUD"] = "AUD";
  Currency2["HKD"] = "HKD";
  Currency2["IDR"] = "IDR";
  Currency2["MYR"] = "MYR";
  Currency2["NZD"] = "NZD";
  Currency2["PHP"] = "PHP";
  Currency2["SGD"] = "SGD";
  Currency2["THB"] = "THB";
  return Currency2;
})(Currency || {});
var Payment2c2pInquiryStatus = /* @__PURE__ */ ((Payment2c2pInquiryStatus2) => {
  Payment2c2pInquiryStatus2["pending"] = "pending";
  Payment2c2pInquiryStatus2["processing"] = "processing";
  Payment2c2pInquiryStatus2["cancelled"] = "cancelled";
  Payment2c2pInquiryStatus2["succeeded"] = "succeeded";
  return Payment2c2pInquiryStatus2;
})(Payment2c2pInquiryStatus || {});
var TaxCode = /* @__PURE__ */ ((TaxCode2) => {
  TaxCode2["GST"] = "GST";
  TaxCode2["VAT"] = "VAT";
  TaxCode2["SST"] = "SST";
  return TaxCode2;
})(TaxCode || {});
var DisplayRecommendation = /* @__PURE__ */ ((DisplayRecommendation2) => {
  DisplayRecommendation2["inclusive"] = "inclusive";
  DisplayRecommendation2["exclusive"] = "exclusive";
  return DisplayRecommendation2;
})(DisplayRecommendation || {});
var AdType = /* @__PURE__ */ ((AdType2) => {
  AdType2["CLASSIC"] = "CLASSIC";
  AdType2["BRANDED"] = "BRANDED";
  AdType2["PREMIUM"] = "PREMIUM";
  AdType2["BRANDED_UPGRADE"] = "BRANDED_UPGRADE";
  AdType2["GUARANTEED"] = "GUARANTEED";
  AdType2["CONCIERGE"] = "CONCIERGE";
  return AdType2;
})(AdType || {});
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["JOB_AD"] = "JOB_AD";
  ProductType2["JOB_AD_EDIT"] = "JOB_AD_EDIT";
  ProductType2["JOB_AD_UPGRADE"] = "JOB_AD_UPGRADE";
  ProductType2["JOB_AD_EXTEND"] = "JOB_AD_EXTEND";
  ProductType2["AD_BUDGET"] = "AD_BUDGET";
  ProductType2["CATALOGUE_PRODUCT"] = "CATALOGUE_PRODUCT";
  return ProductType2;
})(ProductType || {});
var UserIntentType = /* @__PURE__ */ ((UserIntentType2) => {
  UserIntentType2["PREVIEW"] = "PREVIEW";
  UserIntentType2["PURCHASE"] = "PURCHASE";
  return UserIntentType2;
})(UserIntentType || {});
var AdBudgetType = /* @__PURE__ */ ((AdBudgetType2) => {
  AdBudgetType2["CLASSIC_ONWARDS"] = "CLASSIC_ONWARDS";
  AdBudgetType2["BRANDED_ONWARDS"] = "BRANDED_ONWARDS";
  AdBudgetType2["PREMIUM_ONLY"] = "PREMIUM_ONLY";
  return AdBudgetType2;
})(AdBudgetType || {});
var AdTypeTheme = /* @__PURE__ */ ((AdTypeTheme2) => {
  AdTypeTheme2["PRIMARY"] = "PRIMARY";
  AdTypeTheme2["BASIC"] = "BASIC";
  return AdTypeTheme2;
})(AdTypeTheme || {});
var UpgradePathType = /* @__PURE__ */ ((UpgradePathType2) => {
  UpgradePathType2["UpgradeOnly"] = "UpgradeOnly";
  return UpgradePathType2;
})(UpgradePathType || {});
var DurationUnit = /* @__PURE__ */ ((DurationUnit2) => {
  DurationUnit2["YEAR"] = "YEAR";
  DurationUnit2["MONTH"] = "MONTH";
  DurationUnit2["WEEK"] = "WEEK";
  DurationUnit2["DAY"] = "DAY";
  DurationUnit2["HOUR"] = "HOUR";
  DurationUnit2["MINUTE"] = "MINUTE";
  DurationUnit2["SECOND"] = "SECOND";
  return DurationUnit2;
})(DurationUnit || {});
var HirerQuestionType = /* @__PURE__ */ ((HirerQuestionType2) => {
  HirerQuestionType2["SingleSelect"] = "SingleSelect";
  HirerQuestionType2["FreeText"] = "FreeText";
  return HirerQuestionType2;
})(HirerQuestionType || {});
var CandidateAnswerType = /* @__PURE__ */ ((CandidateAnswerType2) => {
  CandidateAnswerType2["SingleSelect"] = "SingleSelect";
  CandidateAnswerType2["FreeText"] = "FreeText";
  return CandidateAnswerType2;
})(CandidateAnswerType || {});
var TalentSearchAccountsOrderByDirection = /* @__PURE__ */ ((TalentSearchAccountsOrderByDirection2) => {
  TalentSearchAccountsOrderByDirection2["desc"] = "desc";
  TalentSearchAccountsOrderByDirection2["asc"] = "asc";
  return TalentSearchAccountsOrderByDirection2;
})(TalentSearchAccountsOrderByDirection || {});
var TalentSearchAccountsOrderByField = /* @__PURE__ */ ((TalentSearchAccountsOrderByField2) => {
  TalentSearchAccountsOrderByField2["advertiserName"] = "advertiserName";
  TalentSearchAccountsOrderByField2["advertiserId"] = "advertiserId";
  return TalentSearchAccountsOrderByField2;
})(TalentSearchAccountsOrderByField || {});
var TalentSearchConnectionType = /* @__PURE__ */ ((TalentSearchConnectionType2) => {
  TalentSearchConnectionType2["UNKNOWN"] = "UNKNOWN";
  TalentSearchConnectionType2["JSP"] = "JSP";
  TalentSearchConnectionType2["ITA"] = "ITA";
  TalentSearchConnectionType2["MSG"] = "MSG";
  TalentSearchConnectionType2["JOB"] = "JOB";
  TalentSearchConnectionType2["PARTNER_MSG"] = "PARTNER_MSG";
  TalentSearchConnectionType2["PROFILE_EXPORT_SEEK"] = "PROFILE_EXPORT_SEEK";
  TalentSearchConnectionType2["PROFILE_EXPORT_SHARED"] = "PROFILE_EXPORT_SHARED";
  TalentSearchConnectionType2["PROFILE_REFRESH"] = "PROFILE_REFRESH";
  TalentSearchConnectionType2["ATS_MSG"] = "ATS_MSG";
  TalentSearchConnectionType2["PROFILE_EXPORT_ATS"] = "PROFILE_EXPORT_ATS";
  return TalentSearchConnectionType2;
})(TalentSearchConnectionType || {});
var TalentSearchConnectionStatus = /* @__PURE__ */ ((TalentSearchConnectionStatus2) => {
  TalentSearchConnectionStatus2["pending"] = "pending";
  TalentSearchConnectionStatus2["redeemed"] = "redeemed";
  TalentSearchConnectionStatus2["rejected"] = "rejected";
  return TalentSearchConnectionStatus2;
})(TalentSearchConnectionStatus || {});
var TalentSearchSendJobStatus = /* @__PURE__ */ ((TalentSearchSendJobStatus2) => {
  TalentSearchSendJobStatus2["ALL_JOBS_SENT"] = "ALL_JOBS_SENT";
  TalentSearchSendJobStatus2["NO_ACTIVE_JOBS"] = "NO_ACTIVE_JOBS";
  TalentSearchSendJobStatus2["HAS_AVAILABLE_JOBS"] = "HAS_AVAILABLE_JOBS";
  return TalentSearchSendJobStatus2;
})(TalentSearchSendJobStatus || {});
var TalentSearchJobsOrderByDirection = /* @__PURE__ */ ((TalentSearchJobsOrderByDirection2) => {
  TalentSearchJobsOrderByDirection2["desc"] = "desc";
  TalentSearchJobsOrderByDirection2["asc"] = "asc";
  return TalentSearchJobsOrderByDirection2;
})(TalentSearchJobsOrderByDirection || {});
var TalentSearchJobsOrderByField = /* @__PURE__ */ ((TalentSearchJobsOrderByField2) => {
  TalentSearchJobsOrderByField2["listed"] = "listed";
  return TalentSearchJobsOrderByField2;
})(TalentSearchJobsOrderByField || {});
var TalentSearchMetadataLocationType = /* @__PURE__ */ ((TalentSearchMetadataLocationType2) => {
  TalentSearchMetadataLocationType2["area"] = "area";
  TalentSearchMetadataLocationType2["state"] = "state";
  TalentSearchMetadataLocationType2["country"] = "country";
  TalentSearchMetadataLocationType2["location"] = "location";
  TalentSearchMetadataLocationType2["majorcities"] = "majorcities";
  TalentSearchMetadataLocationType2["northisland"] = "northisland";
  TalentSearchMetadataLocationType2["southisland"] = "southisland";
  return TalentSearchMetadataLocationType2;
})(TalentSearchMetadataLocationType || {});
var TalentSearchMetadataCulture = /* @__PURE__ */ ((TalentSearchMetadataCulture2) => {
  TalentSearchMetadataCulture2["au"] = "au";
  TalentSearchMetadataCulture2["nz"] = "nz";
  return TalentSearchMetadataCulture2;
})(TalentSearchMetadataCulture || {});
var TalentSearchQuerySalaryType = /* @__PURE__ */ ((TalentSearchQuerySalaryType2) => {
  TalentSearchQuerySalaryType2["ANNUAL"] = "ANNUAL";
  TalentSearchQuerySalaryType2["MONTHLY"] = "MONTHLY";
  TalentSearchQuerySalaryType2["HOURLY_RATE"] = "HOURLY_RATE";
  return TalentSearchQuerySalaryType2;
})(TalentSearchQuerySalaryType || {});
var TalentSearchQuerySortBy = /* @__PURE__ */ ((TalentSearchQuerySortBy2) => {
  TalentSearchQuerySortBy2["RELEVANCE"] = "RELEVANCE";
  TalentSearchQuerySortBy2["CREATED_DATE"] = "CREATED_DATE";
  TalentSearchQuerySortBy2["MODIFIED_DATE"] = "MODIFIED_DATE";
  TalentSearchQuerySortBy2["FRESHNESS"] = "FRESHNESS";
  return TalentSearchQuerySortBy2;
})(TalentSearchQuerySortBy || {});
var PrivacyTypes = /* @__PURE__ */ ((PrivacyTypes2) => {
  PrivacyTypes2["standard"] = "standard";
  PrivacyTypes2["limited"] = "limited";
  return PrivacyTypes2;
})(PrivacyTypes || {});
var ProfileTypes = /* @__PURE__ */ ((ProfileTypes2) => {
  ProfileTypes2["seek"] = "seek";
  ProfileTypes2["combined"] = "combined";
  ProfileTypes2["partner"] = "partner";
  ProfileTypes2["shared"] = "shared";
  return ProfileTypes2;
})(ProfileTypes || {});
var SalaryTypes = /* @__PURE__ */ ((SalaryTypes2) => {
  SalaryTypes2["Annual"] = "Annual";
  SalaryTypes2["Monthly"] = "Monthly";
  SalaryTypes2["Hourly"] = "Hourly";
  return SalaryTypes2;
})(SalaryTypes || {});
var SalaryTypesV2 = /* @__PURE__ */ ((SalaryTypesV22) => {
  SalaryTypesV22["ANNUAL"] = "ANNUAL";
  SalaryTypesV22["MONTHLY"] = "MONTHLY";
  SalaryTypesV22["HOURLY"] = "HOURLY";
  return SalaryTypesV22;
})(SalaryTypesV2 || {});
var ProfileSource = /* @__PURE__ */ ((ProfileSource2) => {
  ProfileSource2["seek"] = "seek";
  ProfileSource2["combined"] = "combined";
  return ProfileSource2;
})(ProfileSource || {});
var TalentSearchContractType = /* @__PURE__ */ ((TalentSearchContractType2) => {
  TalentSearchContractType2["PREMIUM_TALENT_SEARCH"] = "PREMIUM_TALENT_SEARCH";
  TalentSearchContractType2["PREMIUM_TALENT_SEARCH_TRIAL"] = "PREMIUM_TALENT_SEARCH_TRIAL";
  TalentSearchContractType2["CONNECTED_TALENT_SEARCH"] = "CONNECTED_TALENT_SEARCH";
  return TalentSearchContractType2;
})(TalentSearchContractType || {});
var TalentSearchClaim = /* @__PURE__ */ ((TalentSearchClaim2) => {
  TalentSearchClaim2["STANDARD_TALENT_SEARCH"] = "STANDARD_TALENT_SEARCH";
  TalentSearchClaim2["PREMIUM_TALENT_SEARCH"] = "PREMIUM_TALENT_SEARCH";
  TalentSearchClaim2["INTEGRATED_TALENT_SEARCH"] = "INTEGRATED_TALENT_SEARCH";
  TalentSearchClaim2["CONNECTED_TALENT_SEARCH"] = "CONNECTED_TALENT_SEARCH";
  return TalentSearchClaim2;
})(TalentSearchClaim || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "ACTIVE";
  UserStatus2["DEACTIVATED"] = "DEACTIVATED";
  UserStatus2["PENDING"] = "PENDING";
  UserStatus2["FRAUDULENT"] = "FRAUDULENT";
  UserStatus2["SUSPENDED"] = "SUSPENDED";
  UserStatus2["UNVERIFIED"] = "UNVERIFIED";
  return UserStatus2;
})(UserStatus || {});
var UsersParamsFilter = /* @__PURE__ */ ((UsersParamsFilter2) => {
  UsersParamsFilter2["ACTIVE"] = "ACTIVE";
  UsersParamsFilter2["PENDING"] = "PENDING";
  UsersParamsFilter2["DEACTIVATED"] = "DEACTIVATED";
  UsersParamsFilter2["UNVERIFIED"] = "UNVERIFIED";
  return UsersParamsFilter2;
})(UsersParamsFilter || {});
var AccessRightFilter = /* @__PURE__ */ ((AccessRightFilter2) => {
  AccessRightFilter2["ACTIVE"] = "ACTIVE";
  AccessRightFilter2["PENDING"] = "PENDING";
  AccessRightFilter2["DEACTIVATED"] = "DEACTIVATED";
  AccessRightFilter2["ADMIN_ROLE"] = "ADMIN_ROLE";
  AccessRightFilter2["USER_ROLE"] = "USER_ROLE";
  return AccessRightFilter2;
})(AccessRightFilter || {});
var UsersParamsInclude = /* @__PURE__ */ ((UsersParamsInclude2) => {
  UsersParamsInclude2["ACCESS_DETAILS"] = "ACCESS_DETAILS";
  return UsersParamsInclude2;
})(UsersParamsInclude || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["ADMINISTRATOR"] = "ADMINISTRATOR";
  Role2["USER"] = "USER";
  return Role2;
})(Role || {});
var YourCandidatesPayloadErrorType = /* @__PURE__ */ ((YourCandidatesPayloadErrorType2) => {
  YourCandidatesPayloadErrorType2["NOT_FOUND"] = "NOT_FOUND";
  YourCandidatesPayloadErrorType2["INPUT_VALIDATION_ERROR"] = "INPUT_VALIDATION_ERROR";
  YourCandidatesPayloadErrorType2["FORBIDDEN_ERROR"] = "FORBIDDEN_ERROR";
  YourCandidatesPayloadErrorType2["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
  return YourCandidatesPayloadErrorType2;
})(YourCandidatesPayloadErrorType || {});
const GetSuggestedCategoriesDocument = gql`
    query GetSuggestedCategories($jobTitle: String!, $country: String!, $language: String) {
  suggestedCategories(jobTitle: $jobTitle, country: $country, language: $language) {
    category {
      categoryId
      categoryName
      subCategoryId
      subCategoryName
    }
    probability
  }
}
    `;
function useGetSuggestedCategoriesQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetSuggestedCategoriesDocument, options);
}
function useGetSuggestedCategoriesLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetSuggestedCategoriesDocument, options);
}
export {
  AccessRightFilter,
  AccountActivationStatus,
  AdBudgetType,
  AdRatingType,
  AdRepost,
  AdTipsType,
  AdType,
  AdTypeTheme,
  AdUsageAdStatus,
  AdUsageAdType,
  AnalyticsAdRatingConfidence,
  AnalyticsAdRatingScore,
  AnalyticsAdType,
  AnalyticsBenchmarkScenario,
  AnalyticsPostTypeCategory,
  AnalyticsSalaryType,
  AnalyticsWorkType,
  Bank2C2P,
  BillingStatus,
  BrandAssetTypeEnum,
  BrandOwnerType,
  BrandState,
  CacheControlScope,
  CandidateAnswerType,
  CandidateLabel,
  ChannelCode,
  ContractType,
  CreditCardBrandInput,
  Currency,
  DisplayRecommendation,
  DraftJobFlowType,
  DraftJobPaymentOption,
  DraftJobProgress,
  DraftJobSalaryCurrency,
  DraftJobWritingMode,
  DraftStatus,
  DrawdownType,
  DurationUnit,
  ExpireReason,
  FiltersAdRatingType,
  Frequency,
  GetSuggestedCategoriesDocument,
  GuaranteedHireProductCode,
  GuidedDetailsType,
  HirerAccountStatus,
  HirerActivityType,
  HirerGroup,
  HirerJobPostChannel,
  HirerJobStatus,
  HirerJobStatusFilter,
  HirerQuestionType,
  HirerType,
  InvoiceStatus,
  JobAdBookingCountryCode,
  JobAdRating,
  JobAdType,
  JobSalaryCurrency,
  JobStatus,
  LocationContext,
  Payment2c2pInquiryStatus,
  PaymentMethod,
  PaymentMethodType2C2P,
  PriceVisibility,
  PricingModel,
  PrivacyTypes,
  ProductType,
  ProductTypeInput,
  ProfileSource,
  ProfileTypes,
  PublishJobAdProductCode,
  RecommendationType,
  Role,
  SalaryType,
  SalaryTypes,
  SalaryTypesV2,
  StripePaymentMethod,
  TalentSearchAccess,
  TalentSearchAccountsOrderByDirection,
  TalentSearchAccountsOrderByField,
  TalentSearchClaim,
  TalentSearchConnectionStatus,
  TalentSearchConnectionType,
  TalentSearchContractType,
  TalentSearchJobsOrderByDirection,
  TalentSearchJobsOrderByField,
  TalentSearchMetadataCulture,
  TalentSearchMetadataLocationType,
  TalentSearchQuerySalaryType,
  TalentSearchQuerySortBy,
  TalentSearchSendJobStatus,
  TaxCode,
  UpgradePathType,
  UserIntentType,
  UserStatus,
  UsersParamsFilter,
  UsersParamsInclude,
  WorkType,
  YourCandidatesPayloadErrorType,
  useGetSuggestedCategoriesLazyQuery,
  useGetSuggestedCategoriesQuery
};
